import React, { useState, useEffect } from 'react'
import {
  Button,
  Header,
  Icon,
  Modal,
  Segment,
  Message,
  List,
  Grid,
  GridRow,
} from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import contains from 'validator/es/lib/contains'
// import { CreateDeviceCreateTemplateXlsx } from '../../../services/asset'
import { UploadTankCreationFile } from '../../../services/configuration-template/index'
import { CreateXlsx } from '../../../services/xlsx'
import { primaryColor } from '../../../constants'
import IntelMsg from '../../ItelMsg/index'
import { RefreshCustomerDeviceList } from '../../../redux/actions/devices'
import { GetAllCustomers } from '../../../services/customer'
import TankDeviceTemplate from '../../../dummies/Tank_Device_Template.xlsx'

const DeviceBulkUpload = ({ showDeviceBulk, setDeviceBulkShow }) => {
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const productName = localStorage.getItem('product')
  const [message, setMessage] = useState()
  const [customersList, setCustomersList] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [customer, setCustomer] = useState()
  // eslint-disable-next-line no-unused-vars
  const [selectState, setSelectState] = useState()
  // eslint-disable-next-line no-unused-vars
  const [selected, setSelected] = useState(false)

  // const { t } = useTranslation()
  const dispatch = useDispatch()

  const createReport = (data) => {
    const FilesIssuesHeaders = ['Device Number', 'Device Issue']
    const FileIssuesRaw = data['File errors']
    const FileIssuesIssues = []

    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const [key, value] of Object.entries(FileIssuesRaw)) {
      let rowIssues = value.reduce(
        (string, rowIssue) => `${rowIssue}, ${string}`,
        '',
      )
      rowIssues = rowIssues.slice(0, -1)
      const issue = {
        'Row Number': key,
        'Device Issue': rowIssues.slice(0, -1),
      }
      FileIssuesIssues.push(issue)
    }
    CreateXlsx('Devices Issues', FilesIssuesHeaders, FileIssuesIssues)
  }

  useEffect(() => {
    if (userEmail) {
      GetAllCustomers(userEmail, productName).then((data) => {
        console.log('Customer List', data)
        setCustomersList(data || [])
      })
    }
  }, [userEmail])

  const createMessageContent = (data) => {
    const totalUploadedDevices = (
      <List.Item>
        <IntelMsg id="totalDevices" />
        &nbsp;
        {data['Total no. of failure'] + data['Total no. of success']}
      </List.Item>
    )

    const totalSucessDevices = (
      <List.Item>
        <IntelMsg id="successDevices" />
        &nbsp;{data['Total no. of success']}
      </List.Item>
    )
    const faluireDecvices = (
      <List.Item>
        Failed Devices:&nbsp;{data['Total no. of failure']}{' '}
      </List.Item>
    )
    return (
      <List bulleted>
        {totalUploadedDevices}
        {totalSucessDevices}
        {faluireDecvices}
      </List>
    )
  }

  const createErrorMessage = (header, content) => {
    const errorMessage = (
      <Message negative>
        <Message.Header>{header}</Message.Header>
        {content}
      </Message>
    )
    setMessage(errorMessage)
  }

  const handleUpload = (event) => {
    const file = event.target.files[0]
    if (file && contains(file.name, '.xlsx')) {
      UploadTankCreationFile(
        userEmail,
        localStorage.getItem('product'),
        'spectro-tank',
        file,
        customer,
      ).then((res) => {
        if (res.success) {
          dispatch(RefreshCustomerDeviceList(true))
          setMessage('')
          setMessage(
            <Message positive>
              <Message.Header> Result</Message.Header>
              {createMessageContent(res.data)}
              <p>
                Issues report &nbsp;
                <Button size="tiny" onClick={() => createReport(res.data)}>
                  <Icon name="download"></Icon>Export
                </Button>
              </p>
            </Message>,
          )
        } else {
          createErrorMessage('Error !', res.msg)
        }
      })
    } else {
      createErrorMessage(
        'Invalid File Type',
        "File extension should be 'xlsx' ",
      )
    }
  }

  const handleCustomerSelect = (e) => {
    setSelected(true)
    const [id, name] = e.target.value.split(',')
    setCustomer(id)
    setSelectState(e.target.value)
    console.log('m', id, name)
  }

  const handleClose = () => {
    setMessage(null)
    setDeviceBulkShow(false)
  }

  // function createXlsxFile() {
  //   CreateDeviceCreateTemplateXlsx(
  //     localStorage.getItem('product'),
  //     'spectro-tank',
  //     t,
  //   )
  // }

  return (
    <Modal
      closeIcon
      open={showDeviceBulk}
      centered
      style={{ position: 'relative', height: 'auto' }}
      onClose={() => handleClose()}
      onOpen={() => setDeviceBulkShow(true)}
    >
      <Header
        icon="archive"
        content=" Device Bulk Creation "
        style={{ backgroundColor: '#1678c2', color: 'white' }}
      />
      <Modal.Content scrolling>
        <Grid columns={2}>
          <GridRow>
            <Grid.Column width={2}>
              <span style={{ color: 'black' }}>Customer: </span>
            </Grid.Column>

            <Grid.Column width={2}>
              <select
                name="customer"
                style={{
                  width: 410,
                  height: 40,
                }}
                onChange={handleCustomerSelect}
              >
                <option disabled selected>
                  Choose Customer
                </option>
                {customersList.map((item) => (
                  <option
                    key={item.title}
                    value={`${item.tbCustomerId},${item.title}`}
                  >
                    {item.title}
                  </option>
                ))}
              </select>
              <br />
              <small style={{ color: 'red' }}>**</small>
            </Grid.Column>
          </GridRow>
        </Grid>
        <Segment placeholder>
          <Header icon>
            <Icon name="cog" />
            Upload Configurations file
          </Header>
          <Segment.Inline>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '29rem',
                justifyContent: 'space-between',
              }}
            >
              <input
                type="file"
                accept=".xlsx"
                onClick={(event) => {
                  /* eslint-disable-next-line no-param-reassign */
                  event.target.value = null
                }}
                onChange={(event) => handleUpload(event)}
                id="upload"
                style={{ display: 'none' }}
                disabled={!selected}
              />

              <label htmlFor="upload">
                <Button
                  disabled={!selected}
                  style={{ backgroundColor: primaryColor, color: 'white' }}
                  onClick={() => document.getElementById('upload').click()}
                >
                  <Icon name="upload" />
                  Upload Excel File
                </Button>
              </label>
              <a href={TankDeviceTemplate} download="Tank_Device_Template.xlsx">
                <Button primary type="button">
                  <Icon name="download" />
                  Download Template
                </Button>
              </a>
              {/* <ExcelFile initialData={initialData} element={}> */}
              {/*  <ExcelSheet data={dataSet1} name="Employees"> */}
              {/*    <ExcelColumn label="Name" value="name" /> */}
              {/*    <ExcelColumn label="Wallet Money" value="amount" /> */}
              {/*    <ExcelColumn label="Gender" value="sex" /> */}
              {/*    <ExcelColumn */}
              {/*      label="Marital Status" */}
              {/*      value={(col) => (col.is_married ? 'Married' : 'Single')} */}
              {/*    /> */}
              {/*  </ExcelSheet> */}
              {/* </ExcelFile> */}
            </div>
          </Segment.Inline>
        </Segment>

        {message}
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="#303d54"
          style={{ backgroundColor: primaryColor, color: 'white' }}
          onClick={() => {
            handleClose()
          }}
        >
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
DeviceBulkUpload.propTypes = {
  setDeviceBulkShow: PropTypes.func.isRequired,
  showDeviceBulk: PropTypes.bool.isRequired,
}

export default DeviceBulkUpload
